// extracted by mini-css-extract-plugin
export default {"root":"FormWrapper__root--29BHk","errorText":"FormWrapper__errorText--QdLY8","rootMobile":"FormWrapper__rootMobile--1fllW"};